import { computed, ref } from 'vue'

const MAX_MOBILE_VIEWPORT_WIDTH = 1023
const HEADER_SEARCH_MIN_WIDTH = 420

const currentClientWidth = ref(window.innerWidth)
export const isMobileLayout = computed(() => MAX_MOBILE_VIEWPORT_WIDTH >= currentClientWidth.value)
export const isHeaderSearchVisible = computed(() => currentClientWidth.value > HEADER_SEARCH_MIN_WIDTH)

const onResize = () => {
  currentClientWidth.value = window.innerWidth
}

window.addEventListener('resize', onResize)
